module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/activities/activities.component.html
// module id = ./src/app/Pages/activities/activities.component.html
// module chunks = main